module.exports = __webpack_public_path__ + "img/shop-service-filter-nissan.23230440.png";